/** Standard page header: breadcrumb, title, subtitle and an actions slot.
 *
 *  Every page previously hardcoded `<h1 className="text-2xl font-bold
 *  text-gray-900">`. Tailwind's gray-900 (#111827) measures 1.1:1 against the
 *  dark surface, so all 20 page titles were unreadable. Titles must come from
 *  here so they stay on the themed token.
 */
import React from "react";
import Breadcrumb, { Crumb } from "./Breadcrumb";

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  /** Right-aligned controls: exports, refresh, toggles. */
  actions?: React.ReactNode;
  breadcrumb?: Crumb[];
  /** Rendered below the title block — filter bars, tabs, banners. */
  children?: React.ReactNode;
}

export default function PageHeader({
  title,
  subtitle,
  actions,
  breadcrumb,
  children,
}: PageHeaderProps) {
  return (
    <header className="mb-6 flex flex-col gap-3">
      {breadcrumb && breadcrumb.length > 0 ? <Breadcrumb items={breadcrumb} /> : null}

      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="truncate text-2xl font-bold tracking-tight text-content">{title}</h1>
          {subtitle ? (
            <p className="mt-1 text-sm leading-relaxed text-content-muted">{subtitle}</p>
          ) : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>

      {children}
    </header>
  );
}
